import { render, staticRenderFns } from "./TemplateDefault.vue?vue&type=template&id=2326c24c"
import script from "./TemplateDefault.vue?vue&type=script&lang=js"
export * from "./TemplateDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.29._25225b1561639f2a806545d1f6eb5ad4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports